import React from 'react';
import Images from '../../constants/Images';

const LoadingSpinner = () => {
  return (
    <div className={`loading-spinner`}>
      <img src={Images.SpinnerIcon} alt="loading..." />
    </div>
  );
};

export default LoadingSpinner;
